import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { TITLE_INHERIT_STYLE } from "@constants";
import "./css/ContactPreference.scss";
import { useContactPreferences } from "./hook/useContactPreferences";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { FormControl, Radio, RadioGroup } from "@material-ui/core";

export const ContactPreferencePage = () => {
    const {
        userContactPermissions,
        handleChange,
        isCustomer,
        setIsCustomer,
        getContactPreferenceListState,
        updateContactPreferenceListState,
        updateContactPreferences,
        getContactPreference,
        language,
        setLanguage,
    } = useContactPreferences();

    const { t } = useTranslation(["profile", "common", "glossary"]);

    return (
        <div className="contact-preferences">
            <Card elevation={2}>
                {(updateContactPreferenceListState.isLoading || getContactPreferenceListState.isLoading) && (
                    <AbsoluteLoader />
                )}
                <CardHeader
                    className="card-header card-header__right"
                    title={t("profile:myContactPreferences")}
                    titleTypographyProps={TITLE_INHERIT_STYLE}
                />
                <CardContent>
                    <div className="card-header__circle" />
                    <HandleErrorAndLoading
                        error={getContactPreferenceListState.error}
                        isLoading={false}
                        retryFetch={getContactPreference}
                    >
                        <Typography align="center" color="secondary" gutterBottom variant="h4">
                            {t("profile:communicationLang")}
                        </Typography>
                        <Grid container justify="center" style={{ marginBottom: "10px" }}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    name={"language"}
                                    value={language}
                                    onChange={(event) => {
                                        return setLanguage(event.target.value);
                                    }}
                                >
                                    <FormControlLabel value="el" control={<Radio />} label={t("profile:greek")} />
                                    <FormControlLabel value="en" control={<Radio />} label={t("profile:english")} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid container justify="center" spacing={2}>
                            <Grid item>
                                <Button
                                    className={!isCustomer ? "contact-preferences__button-disabled" : ""}
                                    color={isCustomer ? "primary" : "default"}
                                    variant={isCustomer ? "contained" : "outlined"}
                                    onClick={() => setIsCustomer(true)}
                                >
                                    {t("profile:anExistingCustomer")}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    className={isCustomer ? "contact-preferences__button-disabled" : ""}
                                    color={isCustomer ? "default" : "primary"}
                                    variant={isCustomer ? "outlined" : "contained"}
                                    onClick={() => setIsCustomer(false)}
                                >
                                    {t("profile:noLongerCustomer")}
                                </Button>
                            </Grid>
                        </Grid>
                        <Typography color="secondary" gutterBottom variant="body1" style={{ marginTop: "10px" }}>
                            {t("profile:consent")}
                        </Typography>
                        {updateContactPreferenceListState.error && (
                            <Grid
                                alignItems="center"
                                className="contact-preferences__list"
                                container
                                justify="space-between"
                            >
                                <Grid item xs={9}>
                                    <Typography color="error" variant="body2">
                                        {t("common:genericError")}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        {userContactPermissions.map((field, index) => (
                            <Fragment key={field.name}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={field.isEnabled}
                                            name={field.name}
                                            value={field.permission}
                                            onChange={(event) => handleChange(event.target.value)}
                                        />
                                    }
                                    label={t(field.name as any)}
                                />
                                {index !== userContactPermissions.length - 1 && <Divider />}
                            </Fragment>
                        ))}
                        <Grid container justify="center" spacing={2}>
                            {/* <Grid item>
                                <Button color="primary" type="button" variant="outlined" onClick={getContactPreference}>
                                    {t("common:refresh")}
                                </Button>
                            </Grid> */}
                            <Grid item>
                                <Button
                                    color="primary"
                                    type="button"
                                    variant="outlined"
                                    onClick={updateContactPreferences}
                                >
                                    {t("glossary:save")}
                                </Button>
                            </Grid>
                        </Grid>
                    </HandleErrorAndLoading>
                </CardContent>
            </Card>
        </div>
    );
};
